var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdjustment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    className: "st1",
    d: "M65.32,77.5H34.68c-2.13,0-3.86-1.73-3.86-3.86v-1.27c0-2.13,1.73-3.86,3.86-3.86h30.64 c2.13,0,3.86,1.73,3.86,3.86v1.27C69.18,75.77,67.45,77.5,65.32,77.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    className: "st1",
    d: "M65.98,37.18H54.5V25.7c0-1.77-1.43-3.2-3.2-3.2h-2.59c-1.77,0-3.2,1.43-3.2,3.2v11.48H34.02 c-1.77,0-3.2,1.43-3.2,3.2v2.59c0,1.77,1.43,3.2,3.2,3.2H45.5v11.48c0,1.77,1.43,3.2,3.2,3.2h2.59c1.77,0,3.2-1.43,3.2-3.2V46.18 h11.48c1.77,0,3.2-1.43,3.2-3.2v-2.59C69.18,38.61,67.75,37.18,65.98,37.18z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdjustment);
export default __webpack_public_path__ + "static/media/adjustment.ae286dd6306e81c45905a2f2ba150d48.svg";
export { ForwardRef as ReactComponent };